
export default {
  name: "QuickFontSettings",
  props: {
    elements: {
      type: Array,
      default: () => [],
    },
    printOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      minSize: 4,
      maxSize: 72,
      step: 0.5,
    };
  },
  computed: {
    fontElements() {
      return this.elements.filter((element) => {
        if (["text", "field"].includes(element.tipo)) return true;
        return (
          element.tipo === "barcode" &&
          (element.codigo_barras?.exibir_texto !== false ||
            (this.printOptions.considerar_codigo_interno &&
              this.printOptions.codigo_interno_somente_numeracao))
        );
      });
    },
  },
  methods: {
    fontSize(element) {
      const value = Number(element?.estilo?.tamanho_pt);
      return Number.isFinite(value)
        ? Math.min(this.maxSize, Math.max(this.minSize, value))
        : 8;
    },
    typeLabel(element) {
      if (
        element.tipo === "barcode" &&
        this.printOptions.considerar_codigo_interno &&
        this.printOptions.codigo_interno_somente_numeracao
      ) {
        return "Código interno em número";
      }
      return {
        text: "Texto livre",
        field: "Campo da etiqueta",
        barcode: "Número do código de barras",
      }[element.tipo];
    },
    normalize(value) {
      const numeric = Number(String(value).replace(",", "."));
      if (!Number.isFinite(numeric)) return null;
      const clamped = Math.min(this.maxSize, Math.max(this.minSize, numeric));
      return Math.round(clamped / this.step) * this.step;
    },
    emitSize(element, value) {
      const size = this.normalize(value);
      if (size === null || size === this.fontSize(element)) return;
      this.$emit("change", { id: element.id, size });
    },
    adjust(element, amount) {
      this.emitSize(element, this.fontSize(element) + amount);
    },
    applyInput(element, event) {
      const size = this.normalize(event.target.value);
      if (size === null) {
        event.target.value = this.fontSize(element);
        return;
      }
      event.target.value = size;
      this.emitSize(element, size);
    },
  },
};
